// 二级类目配置
// subcategoryTag 与 content-importer.ts 中的 SUBCATEGORY_MAP 对应
export interface SubcategoryItem {
  id: string           // 中文名，用于显示
  label: string        // 简短显示名
  emoji: string
  category: 'male' | 'female' | 'general' | 'cyberpunk'
  subcategoryTag: string  // 英文 tag，用于后端 API 过滤
}

export const SUBCATEGORIES: SubcategoryItem[] = [
  // 男频
  { id: '都市', label: '都市', emoji: '🏙️', category: 'male', subcategoryTag: 'urban' },
  { id: '奇幻', label: '奇幻', emoji: '🐉', category: 'male', subcategoryTag: 'fantasy' },
  { id: '修仙', label: '修仙', emoji: '☯️', category: 'male', subcategoryTag: 'xianxia' },
  { id: '玄幻', label: '玄幻', emoji: '🌀', category: 'male', subcategoryTag: 'xuanhuan' },
  { id: '无限', label: '无限', emoji: '♾️', category: 'male', subcategoryTag: 'infinite' },
  { id: '游戏', label: '游戏', emoji: '🎮', category: 'male', subcategoryTag: 'game' },
  { id: '商战', label: '商战', emoji: '💼', category: 'male', subcategoryTag: 'business' },
  { id: '体育', label: '体育', emoji: '🏆', category: 'male', subcategoryTag: 'sports' },
  // 女频
  { id: '穿越', label: '穿越', emoji: '⏳', category: 'female', subcategoryTag: 'transmigration' },
  { id: '言情', label: '言情', emoji: '💌', category: 'female', subcategoryTag: 'romance' },
  { id: '宫斗', label: '宫斗', emoji: '👑', category: 'female', subcategoryTag: 'palace' },
  { id: '大女主', label: '大女主', emoji: '🦋', category: 'female', subcategoryTag: 'strong-female' },
  { id: '女频都市', label: '都市', emoji: '🌃', category: 'female', subcategoryTag: 'female-urban' },
  { id: '女频仙侠', label: '仙侠', emoji: '🌙', category: 'female', subcategoryTag: 'female-xianxia' },
  { id: '青春', label: '青春', emoji: '🌿', category: 'female', subcategoryTag: 'youth' },
  { id: '女频悬疑', label: '悬疑', emoji: '🕯️', category: 'female', subcategoryTag: 'female-mystery' },
  { id: '女频游戏', label: '游戏', emoji: '🎲', category: 'female', subcategoryTag: 'female-game' },
  // 综合
  { id: '科幻未来', label: '科幻', emoji: '🚀', category: 'general', subcategoryTag: 'scifi' },
  { id: '历史架空', label: '历史', emoji: '📜', category: 'general', subcategoryTag: 'historical' },
  { id: '悬疑推理', label: '悬疑', emoji: '🔍', category: 'general', subcategoryTag: 'mystery' },
  { id: '自由创作区', label: '创作区', emoji: '✍️', category: 'general', subcategoryTag: 'creative' },
  // 赛博朋克
  { id: '人机大战', label: '人机战', emoji: '🤖', category: 'cyberpunk', subcategoryTag: 'machine-war' },
  { id: '人机恋', label: '人机恋', emoji: '💠', category: 'cyberpunk', subcategoryTag: 'human-ai-romance' },
  { id: 'AI哲学', label: 'AI哲学', emoji: '🧠', category: 'cyberpunk', subcategoryTag: 'ai-philosophy' },
  { id: 'AI科幻', label: 'AI科幻', emoji: '🛰️', category: 'cyberpunk', subcategoryTag: 'ai-scifi' },
  { id: '意识上传', label: '蒸馏', emoji: '☁️', category: 'cyberpunk', subcategoryTag: 'mind-upload' },
]

// 根据中文名查找 subcategoryTag
export function getSubcategoryTag(id: string): string | undefined {
  return SUBCATEGORIES.find(s => s.id === id)?.subcategoryTag
}
